import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ArticleIcon from '@mui/icons-material/Article'

import { PaperListStyle } from '../styles'
import PaperModal from '../modals/PaperModal'
import ResourceDescription from '../shared/ResourceDescription'
import ResourceList from './ResourceList'
import { openExternal } from '../../utils/safeUrl'

const PaperList = (props) => {
    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    const secondary = (
        <>
            <ResourceDescription
                description={props.description}
                containerSx={PaperListStyle.titleContainer}
                typographyProps={{ ...PaperListStyle.description, gutterBottom: true }}
            />
            <Box sx={PaperListStyle.secondary}>
                <Typography variant='p'>
                    <span style={{"fontWeight":"bold"}}>Authors:</span> {props.authors}
                </Typography>
            </Box>
            <Box sx={PaperListStyle.secondary}>
                <Typography variant='p'>
                    <span style={{"fontWeight":"bold"}}>DOI:</span> {props.doi}
                </Typography>
            </Box>
        </>
    )

    return (
        <ResourceList
            Icon={ArticleIcon}
            listStyle={PaperListStyle}
            modal={<PaperModal {...props} />}
            title={props.title}
            date={props.pub_date}
            content_tags={props.content_tags}
            medical_specialty_tags={props.medical_specialty_tags}
            is_seminal_work={props.is_seminal_work || props.seminal_work}
            onOpen={openResource}
            secondaryContent={secondary}
        />
    )
}

export default PaperList
